import { Badge } from '@/components/ui/badge'
import type { Visibility } from '@/api/types'

const LABEL: Record<Visibility, string> = {
  PUBLIC: 'Public',
  UNLISTED: 'Unlisted',
  PRIVATE: 'Private',
}

const VARIANT: Record<Visibility, 'default' | 'secondary' | 'outline'> = {
  PUBLIC: 'default',
  UNLISTED: 'outline',
  PRIVATE: 'secondary',
}

export const VisibilityBadge = ({ visibility }: { visibility: Visibility }) => (
  <Badge variant={VARIANT[visibility]}>{LABEL[visibility]}</Badge>
)
